// Central registry of all games. To add a new game:
//   1. Register a backend key in server.py PAYOUT_FNS (path games can just add to PATH_GAMES)
//   2. Add a page component under /pages/games/
//   3. Append one entry here — the lobby and router auto-pick it up.

import { Brain, Grid3x3, Bomb, Bird, Home, Fish, Sparkles } from "lucide-react";

// Lobby renders `GAMES` in order. `path` is the frontend route.
export const GAMES = [
  {
    id: "memory",
    label: "Memory Matrix",
    icon: Brain,
    blurb: "Pair the deck before the clock burns. Faster clears yield higher multipliers.",
    path: "/play/memory",
    tint: "from-amber-500/10",
  },
  {
    id: "2048",
    label: "2048 Vault",
    icon: Grid3x3,
    blurb: "Merge with intent. Each tier you cross unlocks a fatter payout multiplier.",
    path: "/play/2048",
    tint: "from-emerald-500/10",
  },
  {
    id: "minesweeper",
    label: "Minesweeper Tactical",
    icon: Bomb,
    blurb: "Reveal safe tiles, cash out any time. Every step multiplies the pot.",
    path: "/play/minesweeper",
    tint: "from-red-500/10",
  },
  {
    id: "chicken",
    label: "Chicken Road",
    icon: Bird,
    blurb: "Cross lane by lane through traffic. Every crossing lifts the pot — dodge or splat.",
    path: "/play/chicken",
    tint: "from-sky-500/10",
  },
  {
    id: "realtor",
    label: "Realtor Run",
    icon: Home,
    blurb: "Sell house after house to grow the pot. Cash out before the next one forecloses.",
    path: "/play/realtor",
    tint: "from-orange-500/10",
  },
  {
    id: "jeff",
    label: "Jeff's Weekend",
    icon: Fish,
    blurb: "A salmon dodges hooks upstream. Multipliers rise every current — until the line pulls.",
    path: "/play/jeff",
    tint: "from-cyan-500/10",
  },
  {
    id: "frogger",
    label: "Frogger",
    icon: () => (
      <svg width="24" height="24" viewBox="0 0 40 40" shapeRendering="crispEdges" aria-hidden>
        <rect x="10" y="10" width="20" height="20" fill="#22C55E" stroke="#0B0D10" strokeWidth="2" />
        <rect x="14" y="14" width="4" height="4" fill="#FFF" />
        <rect x="22" y="14" width="4" height="4" fill="#FFF" />
      </svg>
    ),
    blurb: "Modern retro — hop lane to lane, dodge the pixel traffic, cash out any time. Max 10×.",
    path: "/play/frogger",
    tint: "from-lime-500/10",
  },
  {
    id: "unicorn",
    label: "Magic Monday",
    icon: Sparkles,
    blurb: "Your horse becomes a unicorn and flies. Cash out before the spell breaks — dodge the storm clouds.",
    path: "/play/unicorn",
    tint: "from-fuchsia-500/10",
  },
];
